// src/api/expenses.api.js
import axiosInstance from './axiosInstance';

/**
 * جلب حسابات المصاريف
 * @param {'booking'|'general'|undefined} type - فلتر النوع (اختياري)
 */
export const fetchExpenseCategories = (type) =>
  axiosInstance.get('/expense-categories/', {
    params: type ? { type } : {},
  });

/**
 * إنشاء حساب مصروف جديد
 * @param {{ name: string, is_booking_related: boolean }} payload
 */
export const createExpenseCategory = (payload) =>
  axiosInstance.post('/expense-categories/', payload);

/**
 * تحديث حساب مصروف
 * @param {number} id
 * @param {{ name?: string, is_booking_related?: boolean }} payload
 */
export const updateExpenseCategory = (id, payload) =>
  axiosInstance.patch(`/expense-categories/${id}/`, payload);

/**
 * إضافة مصروف (عام أو مرتبط بحجز)
 * @param {{ category: number, description: string, amount: number, expense_date: string, booking?: number }} payload
 */
export const createExpense = (payload) =>
  axiosInstance.post('/expenses/', payload);

/**
 * حذف مصروف
 * @param {number} id
 */
export const deleteExpense = (id) =>
  axiosInstance.delete(`/expenses/${id}/`);

/**
 * جلب تقرير المصاريف مع فلاتر
 * @param {Object} filters
 */
export const fetchExpenseReport = (filters = {}) =>
  axiosInstance.get('/expense-report/', { params: filters });